<div class="kb-page" id="dct-avance">
  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title">Aceptación CrediTotal</h1>
      <p class="kb-page-desc">Cuentas domiciliadas en BDV y Mercantil que ya aceptaron los términos de CrediTotal.</p>
    </div>
    <span *ngIf="datos" class="kb-badge kb-badge-contorno">{{ textoInvitacion() }}</span>
  </div>

  <div *ngIf="sinPermiso" class="kb-aviso kb-aviso-info" id="dct-avance-sin-permiso">
    <i class="fas fa-lock"></i><div>No tiene permiso para ver esta pantalla.</div>
  </div>

  <div *ngIf="error" class="kb-aviso kb-aviso-peligro mb-3" id="dct-avance-error">
    <i class="fas fa-exclamation-triangle"></i>
    <div>{{ error }} <button type="button" class="kb-btn kb-btn-outline kb-btn-sm ml-2" (click)="cargar(false)">Reintentar</button></div>
  </div>

  <div *ngIf="(cargando || calculando) && !datos && !sinPermiso && !error" class="kb-hint" id="dct-avance-cargando">
    <i class="fas fa-circle-notch fa-spin"></i> Calculando el avance… puede tardar unos minutos; la página se actualiza sola.
  </div>

  <div *ngIf="vacio" class="kb-empty" id="dct-avance-vacio">
    <div class="kb-empty-titulo">Todavía no hay cuentas por medir</div>
    <div class="kb-empty-texto">No hay cuentas domiciliadas en BDV o Mercantil.</div>
  </div>

  <ng-container *ngIf="datos && !vacio">
    <!-- Avance diario: primero, para ver el ritmo y actuar si se frena -->
    <div class="kb-card mb-3" id="dct-avance-diario">
      <div class="kb-card-header">
        <div class="kb-card-title">Avance diario</div>
        <div class="kb-card-desc">Aceptaciones por día, últimos 30 días · hoy {{ num(ritmo.hoy) }} · ayer {{ num(ritmo.ayer) }} · promedio 7 días {{ num(ritmo.promedio7) }} al día</div>
      </div>
      <div class="kb-card-body">
        <div class="flex items-end gap-0.5 h-24" id="dct-avance-dias">
          <div *ngFor="let d of dias" class="flex-1 h-full flex items-end" [title]="tituloDia(d)">
            <div class="w-full rounded-t" [ngClass]="d.aceptaron ? 'bg-primary/70' : 'bg-muted'" [style.height]="altoBarra(d.aceptaron)"></div>
          </div>
        </div>
        <div class="flex justify-between kb-hint mt-1">
          <span>{{ fechaCorta(dias[0]?.fecha || "") }}</span>
          <span>Hoy</span>
        </div>
      </div>
    </div>

    <!-- Global -->
    <div class="kb-card mb-3">
      <div class="kb-card-body">
        <div class="flex items-end gap-3">
          <div class="text-5xl font-semibold leading-none" id="dct-avance-pct">{{ pct(datos.total?.porcentaje, datos.total?.aceptaron) }}</div>
          <div class="text-sm text-muted-foreground pb-1">
            {{ num(datos.total?.aceptaron) }} de {{ num(datos.total?.universo) }} cuentas · faltan {{ num(datos.total?.faltan) }}
          </div>
        </div>
        <div class="h-2 w-full rounded-full bg-muted mt-3 overflow-hidden">
          <div class="h-2 rounded-full bg-primary" [style.width]="ancho(datos.total?.porcentaje)"></div>
        </div>
        <div *ngIf="datos.piloto" class="kb-hint mt-2" id="dct-avance-piloto">
          Grupo piloto: {{ num(datos.piloto.aceptaron) }} de {{ num(datos.piloto.universo) }} ({{ pct(datos.piloto.porcentaje, datos.piloto.aceptaron) }})
        </div>
      </div>
    </div>

    <!-- Por banco y producto -->
    <div class="kb-table-envoltorio mb-3">
      <table class="kb-table" id="dct-avance-tabla">
        <thead class="kb-thead">
          <tr>
            <th class="kb-th">Banco</th>
            <th class="kb-th">Producto</th>
            <th class="kb-th kb-th-num">Deben aceptar</th>
            <th class="kb-th kb-th-num">Aceptaron</th>
            <th class="kb-th kb-th-num">%</th>
            <th class="kb-th" style="width: 8rem"></th>
            <th class="kb-th kb-th-num">Faltan</th>
          </tr>
        </thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let f of datos.filas">
            <td class="kb-td kb-td-titulo">{{ f.banco || f.bank }}</td>
            <td class="kb-td">{{ producto(f.product_type) }}</td>
            <td class="kb-td kb-td-num">{{ num(f.universo) }}</td>
            <td class="kb-td kb-td-num">{{ num(f.aceptaron) }}</td>
            <td class="kb-td kb-td-num">{{ pct(f.porcentaje, f.aceptaron) }}</td>
            <td class="kb-td">
              <div class="h-1.5 w-full rounded-full bg-muted overflow-hidden"><div class="h-1.5 rounded-full bg-primary" [style.width]="ancho(f.porcentaje)"></div></div>
            </td>
            <td class="kb-td kb-td-num">{{ num(f.faltan) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </ng-container>

  <div *ngIf="!sinPermiso" class="flex items-center justify-end gap-3 mt-3">
    <span *ngIf="calculando && datos" class="kb-hint"><i class="fas fa-circle-notch fa-spin"></i> Recalculando…</span>
    <span *ngIf="errorExcel" class="kb-hint" id="dct-avance-excel-error" style="color: var(--kb-peligro, #b91c1c)">{{ errorExcel }}</span>
    <button *ngIf="datos" type="button" class="kb-btn kb-btn-outline kb-btn-sm" id="dct-avance-excel" [disabled]="descargando" (click)="descargarExcel()" title="Una fila por cuenta, con quién aceptó y quién falta">
      <i class="fas" [ngClass]="descargando ? 'fa-circle-notch fa-spin' : 'fa-file-excel'"></i> {{ descargando ? 'Preparando…' : 'Descargar Excel' }}
    </button>
    <span *ngIf="datos" class="kb-hint" id="dct-avance-actualizado">{{ textoActualizado }}</span>
    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" [disabled]="cargando" (click)="cargar(true)">
      <i class="fas fa-sync-alt" [class.fa-spin]="cargando"></i> Actualizar
    </button>
  </div>
</div>
